export default __webpack_public_path__ + "static/media/dponet-logo-blue.8fad12bd.svg";